import {createStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import createRootReducer from '../../slices'
import {orderInterruptedMiddleware, sentryMiddleware, sessionSync} from '../../store/middlewares'
import auth from '../../store/middlewares/auth'
import uiEventLogger from '../../store/middlewares/uiEventLoggerMiddleware'

import OrderTemporarySentryEnhancer from './sentryEnhancer'

/**
 * 최초 react-router 동작을 위한 임시 스토어
 */
export const temporaryStore = createStore({
    rootReducerCreator: createRootReducer,
    middlewares: [auth, orderInterruptedMiddleware, sessionSync, sentryMiddleware, uiEventLogger, browserEventEmitter],
    sentryEnhancerOptions: OrderTemporarySentryEnhancer,
})
